


























































































































































































import Vue from "vue";
import { Component, Inject, Watch } from "vue-property-decorator";
import { SearchInvoiceDTO } from "../../../model/data.model";
import Pagination from "../../shared/Pagination.vue";
import { isItaly, isUk } from "./../../../services/Helpers";
import SearchDateRange, {
  DateRangeModel
} from "@/components/shared/SearchDateRange.vue";

import {
  GetInvoiceResults,
  InvoiceListItem,
  SearchParams,
  IPagination
} from "../../../model/component.model";
import { BillingService } from "../../../services/BillingService";
import BillingManagementToolbar from "./BillingManagementToolbar.vue";
import i18n from "@/lang/i18n";

@Component({
  components: {
    Pagination: Pagination,
    Toolbar: BillingManagementToolbar,
    SearchDateRange
  }
})
export default class BillingManagement extends Vue {
  @Inject() billingService: BillingService;

  invoices: InvoiceListItem[] = [];
  salesTypes: number[] = [];
  allInvoicesSelected = false;

  searchParams: SearchParams = {
    search: "",
    orderField: "",
    orderDirection: "asc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  datesInvoices: DateRangeModel = {
    dateStart: new Date(new Date().getFullYear(), 0, 1),
    dateEnd: new Date()
  };

  created() {
    BillingService.getSearchableSalesTypes().then((res: number[]) => {
      this.invoices = [];
      this.salesTypes = res;
      this.search();
    });
  }

  selectItem(item: InvoiceListItem) {
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allInvoicesSelected = value;
    this.invoices.forEach((invoice: InvoiceListItem) => {
      invoice.selected = value;
    });
  }
  formatInteger(value) {
    if (isItaly()) {
      return value.replace(".", ",");
    }
    if (isUk()) {
      return new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(value));
    }
    return value;
  }
  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }

  invoicesSelected() {
    return this.invoices.filter((invoice: InvoiceListItem) => invoice.selected);
  }

  @Watch("searchParams.search")
  search() {
    // Ensure that selectAll radio checkbox is deselected
    this.selectAll(false);

    this.invoices = [];
    this.billingService
      .getInvoices(this.searchParams, this.salesTypes, this.datesInvoices)
      .then((res: GetInvoiceResults) => {
        res.invoices.forEach((item: SearchInvoiceDTO) => {
          const o: InvoiceListItem = { ...(item as InvoiceListItem) };
          o.selected = false;
          this.invoices.push(o);
        });
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  @Watch("searchParams.sort") changeSortField() {
    this.search();
  }
  @Watch("searchParams.direction") changeSortDirection() {
    this.search();
  }

  sortTable(field: string, direction: string) {
    this.searchParams.orderField = field;
    this.searchParams.orderDirection = direction;
  }

  get firstPage() {
    return this.searchParams.page === 0;
  }

  get lastPage() {
    return this.searchParams.page === this.searchParams.totalPages - 1;
  }

  // Page navigation function
  prev() {
    if (!this.firstPage) {
      this.searchParams.page--;
      this.search();
    }
  }

  next() {
    if (!this.lastPage) {
      this.searchParams.page++;
      this.search();
    }
  }

  printInvoices() {
    const invoicesIds = this.invoicesSelected().map(item => item.documentId);
    BillingService.printInvoices(
      this.$store.getters["customer/info"].defaultStoreId,
      invoicesIds
    )
      .then(res => {
        /*invoicesIds.forEach(
						(id) => {
							window.open(res[id][0].path, '_blank')
						})*/
        let successCount = 0;
        let errorMessages = "";
        // keys has an array of documents
        Object.keys(res).map((k: any) => {
          let alreadyIncremented = false;
          for (let i = 0; i < res[k].length; i++) {
            if (!res[k][i].errorMessage) {
              if (!alreadyIncremented) {
                successCount = successCount + 1;
                alreadyIncremented = true;
              }
            } else {
              errorMessages =
                errorMessages +
                "<br>" +
                (res[k][i].errorMessageDetails +
                  " " +
                  i18n.t(res[k][i].errorMessage));
            }
          }
        });

        if (Object.keys(res).length - successCount) {
          this.$alerts.danger(
            '<h4 class="text-center">' +
              i18n.t("printed") +
              "</h4><br><br>" +
              i18n.t("print_count") +
              ": " +
              '<span class="modal-count-success">' +
              successCount +
              "</span> " +
              i18n.t("on_error_count") +
              ": " +
              '<span class="modal-count-error">' +
              (Object.keys(res).length - successCount) +
              "</span>" +
              "<br><br>" +
              errorMessages
          );
        }

        invoicesIds.forEach((id: any) =>
          res[id].forEach((doc: any) => {
            if (doc.path) {
              window.open(doc.path, "_blank");
            }
          })
        );
      })
      .catch(err => {
        this.$alerts.danger(err.response.data.code);
      });
  }
  get uk() {
    return isUk();
  }
}
